import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import WebRoutes from './routes/WebRoutes';
import AdminRoutes from './routes/AdminRoutes';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/*" element={<WebRoutes />} />
        <Route path="/admin/*" element={<AdminRoutes />} />
      </Routes>
    </Router>
  );
}

export default App;